module.exports = __webpack_public_path__ + "img/flomsone.f689c006.jpg";